export const reportData = {
    /* ciberseguridad data */
    
     
    sobreAtaquesDdosInvestigacion: {
        es: {title: 'Investigación sobre ataques DDoS'},
        en: {title: 'A Study of DDoS Attacks'},
        pt: {title: 'Pesquisa sobre ataques de DDoS'},
    },
    investigacionAtaquesDdos: {
        es: {
            title: 'Investigación sobre ataques DDoS',
            items: [
                { id: 'p1', label: 'Resumen' },
                { id: 'p2', label: 'Objetivo' },
                { id: 'p3', label: 'Relevamiento' },
                { id: 'p4', label: 'Buenas Prácticas' },
                { id: 'p5', label: 'Técnicas de mitigación' }, 
                { id: 'p6', label: 'Conclusiones' },
                { id: 'p7', label: 'Otras Referencias' }
            ]
        },
        en: {
            title: 'A Study of DDoS Attacks',
            items: [
                { id: 'p1', label: 'Summary' },
                { id: 'p2', label: 'Purpose' },
                { id: 'p3', label: 'Information Gathering' },
                { id: 'p4', label: 'Best Practices' },
                { id: 'p5', label: 'Mitigation techniques' }, 
                { id: 'p6', label: 'Conclusions' },
                { id: 'p7', label: 'Additional references' }
            ]
        },
        pt: {
            title: 'Pesquisa sobre ataques de DDoS',
            items: [
                { id: 'p1', label: 'Resumo' },
                { id: 'p2', label: 'Objetivos' },
                { id: 'p3', label: 'Enquete' },
                { id: 'p4', label: 'Boas práticas' },
                { id: 'p5', label: 'Técnicas de mitigação' }, 
                { id: 'p6', label: 'Conclusões' },
                { id: 'p7', label: 'Outras referências' }
            ]
        }
    },
    
    antiSpoofing: {
        es: {
            title: 'Estudio anti-spoofing en la región',
             
        },
        en: {
            title: 'Study on Anti-spoofing in the Region',
             
        },
        pt: {
            title: 'Estudo anti-spoofing na região',
             
        }
    }, 
    vulnerabilidadAtaquesDdos: {
        es: {
            title: 'Estudio de recursos de internet de la región LAC que posibilitan ataques de DDoS',
            items: [
                { id: 'p1', label: 'Resumen' },
                { id: 'p2', label: 'Objetivo' },
                { id: 'p3', label: 'Motivación' },
                { id: 'p4', label: 'Análisis preliminar del problema' },
                { id: 'p5', label: 'Relevamiento inicial' },
                { id: 'p6', label: 'Acciones realizadas' },
                { id: 'p7', label: 'Resultado de las acciones' },
                { id: 'p8', label: 'Conclusiones' },
                { id: 'p9', label: 'Referencias' }
            ]
        },
        en: {
            title: 'Study of Internet Resources in the LACNIC Service Region that Use UDP and Enable DDoS Attacks',
            items: [
                { id: 'p1', label: 'Abstract' },
                { id: 'p2', label: 'Purpose' },
                { id: 'p3', label: 'Motivation' },
                { id: 'p4', label: 'Preliminary Analysis of the Problem' },
                { id: 'p5', label: 'Initial Survey' },
                { id: 'p6', label: 'Actions' },
                { id: 'p7', label: 'Result of the Actions' },
                { id: 'p8', label: 'Conclusions' },
                { id: 'p9', label: 'References' }
            ]
        },
        pt: {
            title: 'Estudo dos recursos da Internet presentes na região do LACNIC com protocolos UDP que possibilitam ataques do tipo DDoS',
            items: [
                { id: 'p1', label: 'Resumo' },
                { id: 'p2', label: 'Objetivo' },
                { id: 'p3', label: 'Motivação' },
                { id: 'p4', label: 'Análise preliminar do problema' },
                { id: 'p5', label: 'Levantamento inicial' },
                { id: 'p6', label: 'Ações realizadas' },
                { id: 'p7', label: 'Resultado das ações' },
                { id: 'p8', label: 'Conclusões' },
                { id: 'p9', label: 'Referências' }
            ]
        }
    },
    ataquesDdosComoMitigarlos : {
        es: {title: 'Ataques DDoS y cómo mitigarlos'},
        en: {title: 'DDoS Attacks and How to Mitigate Them'},
        pt: {title: 'Ataques de DDoS e como mitigá-los'}
    },
    unaHistoriaDeExitoEnCiberseguridad: {
        es: {title : 'Una historia de éxito en ciberseguridad'},
        en: {title : 'A Cybersecurity Success Story'},
        pt: {title : 'Una historia de éxito en ciberseguridad'},  
    },
    dnsOpenResolversIPv4Data: {
        es: {title: 'DNS open resolvers con IPv4 que involucran recursos bajo la administración de LACNIC'},
        en: {title: 'DNS IPv4 Open Resolvers Hosted on LACNIC-Managed Number Resources'},
        pt: {title: 'DNS open resolvers com IPv4 que envolvam recursos sob a administração do LACNIC'},
    },
    /* Interconexion */
    analisisCaminosPaisLac: {
        es: {title: 'analisis-de-caminos-desde-cada-pais-hacia-el-resto-de-la-region'},
        en: {title: 'analisis-de-caminos-desde-cada-pais-hacia-el-resto-de-la-region'},
        pt: {title: 'analisis-de-caminos-desde-cada-pais-hacia-el-resto-de-la-region'},
    },
    evolucionGlobalRPKI: {
        es: {title: 'Evolución global y regional de la adopción de RPKI'},
        en: {title: 'Global and Regional Evolution of RPKI Adoption'},
        pt: {title: 'Evolución global y regional de la adopción de RPKI'},
    },
    analisisDeFuncionamientoDelTrustAnchorTaDeRpkiV1: {
        es: {title: 'Análisis de funcionamiento del Trust Anchor (TA) de RPKI v1'},
        en: {title: 'Análisis de funcionamiento del Trust Anchor (TA) de RPKI v1'},
        pt: {title: 'Análisis de funcionamiento del Trust Anchor (TA) de RPKI v1'},
    },
    interconexionBgp: {
        es: {
            title: 'Interconexión en BGP en la región de América Latina y el Caribe',
            items: [
                { id: 'bgp1', label: 'Resumen' },
                { id: 'bgp2', label: 'Introducción' },
                { 
                    id: 'bgp3', 
                    label: 'Metodología',
                    subitems: [
                        { id: 'a1', label: 'Objetivos planteados' },
                        { id: 'a2', label: 'Fuentes de datos' },
                        { id: 'a3', label: 'Procesamiento de la información' },
                        { id: 'a4', label: 'Datasets generados' }
                    ]
                },
                { 
                    id: 'bgp4', 
                    label: 'Datos por país',
                    subitems: [
                        { id: 'argentina', label: 'Argentina' },
                        { id: 'aruba', label: 'Aruba' },
                        { id: 'bolivia', label: 'Bolivia' },
                        { id: 'brasil', label: 'Brasil' },
                        { id: 'chile', label: 'Chile' },
                        { id: 'colombia', label: 'Colombia' },
                        { id: 'costa-rica', label: 'Costa Rica' },
                        { id: 'cuba', label: 'Cuba' },
                        { id: 'republica-dominicana', label: 'República Dominicana' },
                        { id: 'ecuador', label: 'Ecuador' },
                        { id: 'guyana-francesa', label: 'Guyana Francesa' },
                        { id: 'guatemala', label: 'Guatemala' },
                        { id: 'guyana', label: 'Guyana' },
                        { id: 'honduras', label: 'Honduras' },
                        { id: 'haiti', label: 'Haití' },
                        { id: 'mexico', label: 'México' },
                        { id: 'nicaragua', label: 'Nicaragua' },
                        { id: 'panamá', label: 'Panamá' },
                        { id: 'perú', label: 'Perú' },
                        { id: 'paraguay', label: 'Paraguay' },
                        { id: 'surinam', label: 'Surinam' },
                        { id: 'el-salvador', label: 'El Salvador' },
                        { id: 'trinidad-y-tobago', label: 'Trinidad y Tobago' },
                        { id: 'uruguay', label: 'Uruguay' },
                        { id: 'venezuela', label: 'Venezuela' }
                    ]
                },
                { id: 'bgp5', label: 'Análisis de los datos a nivel regional' },
                { id: 'bgp6', label: 'Conclusiones y trabajo a futuro' },
                { id: 'bgp7', label: 'Referencias' }
            ]
        },
        en: {
            title: 'BGP Interconnection in the Region of Latin America and the Caribbean',
            items: [
                { id: 'bgp1', label: 'Abstract' },
                { id: 'bgp2', label: 'Introduction' },
                { 
                    id: 'bgp3', 
                    label: 'Methodology',
                    subitems: [
                        { id: 'a1', label: 'Objectives' },
                        { id: 'a2', label: 'Data Sources' },
                        { id: 'a3', label: 'Data Processing' },
                        { id: 'a4', label: 'Generated Datasets' }
                    ]
                },
                { 
                    id: 'bgp4', 
                    label: 'Data by Country',
                    subitems: [
                        { id: 'argentina', label: 'Argentina' },
                        { id: 'aruba', label: 'Aruba' },
                        { id: 'bolivia', label: 'Bolivia' },
                        { id: 'brasil', label: 'Brasil' },
                        { id: 'chile', label: 'Chile' },
                        { id: 'colombia', label: 'Colombia' },
                        { id: 'costa-rica', label: 'Costa Rica' },
                        { id: 'cuba', label: 'Cuba' },
                        { id: 'republica-dominicana', label: 'República Dominicana' },
                        { id: 'ecuador', label: 'Ecuador' },
                        { id: 'guyana-francesa', label: 'Guyana Francesa' },
                        { id: 'guatemala', label: 'Guatemala' },
                        { id: 'guyana', label: 'Guyana' },
                        { id: 'honduras', label: 'Honduras' },
                        { id: 'haiti', label: 'Haití' },
                        { id: 'mexico', label: 'México' },
                        { id: 'nicaragua', label: 'Nicaragua' },
                        { id: 'panamá', label: 'Panamá' },
                        { id: 'perú', label: 'Perú' },
                        { id: 'paraguay', label: 'Paraguay' },
                        { id: 'surinam', label: 'Surinam' },
                        { id: 'el-salvador', label: 'El Salvador' },
                        { id: 'trinidad-y-tobago', label: 'Trinidad y Tobago' },
                        { id: 'uruguay', label: 'Uruguay' },
                        { id: 'venezuela', label: 'Venezuela' }
                    ]
                },
                { id: 'bgp5', label: 'Regional Data Analysis' },
                { id: 'bgp6', label: 'Conclusions and Future Work' },
                { id: 'bgp7', label: 'References' }
            ]
        },
        pt: {
            title: 'Interconexão no BGP na região da América Latina e o Caribe',
            items: [
                { id: 'bgp1', label: 'Resumo' },
                { id: 'bgp2', label: 'Introdução' },
                { 
                    id: 'bgp3', 
                    label: 'Metodologia',
                    subitems: [
                        { id: 'a1', label: 'Objetivos definidos' },
                        { id: 'a2', label: 'Fontes de dados' },
                        { id: 'a3', label: 'Processamento das informações' },
                        { id: 'a4', label: 'Datasets gerados' }
                    ]
                },
                { 
                    id: 'bgp4', 
                    label: 'Dados por país',
                    subitems: [
                        { id: 'argentina', label: 'Argentina' },
                        { id: 'aruba', label: 'Aruba' },
                        { id: 'bolivia', label: 'Bolivia' },
                        { id: 'brasil', label: 'Brasil' },
                        { id: 'chile', label: 'Chile' },
                        { id: 'colombia', label: 'Colombia' },
                        { id: 'costa-rica', label: 'Costa Rica' },
                        { id: 'cuba', label: 'Cuba' },
                        { id: 'republica-dominicana', label: 'República Dominicana' },
                        { id: 'ecuador', label: 'Ecuador' },
                        { id: 'guyana-francesa', label: 'Guyana Francesa' },
                        { id: 'guatemala', label: 'Guatemala' },
                        { id: 'guyana', label: 'Guyana' },
                        { id: 'honduras', label: 'Honduras' },
                        { id: 'haiti', label: 'Haití' },
                        { id: 'mexico', label: 'México' },
                        { id: 'nicaragua', label: 'Nicaragua' },
                        { id: 'panamá', label: 'Panamá' },
                        { id: 'perú', label: 'Perú' },
                        { id: 'paraguay', label: 'Paraguay' },
                        { id: 'surinam', label: 'Surinam' },
                        { id: 'el-salvador', label: 'El Salvador' },
                        { id: 'trinidad-y-tobago', label: 'Trinidad y Tobago' },
                        { id: 'uruguay', label: 'Uruguay' },
                        { id: 'venezuela', label: 'Venezuela' }
                    ]
                },
                { id: 'bgp5', label: 'Análise dos dados a nível regional' },
                { id: 'bgp6', label: 'Conclusões e trabalho futuro' },
                { id: 'bgp7', label: 'Referências' }
            ]
        }
    },
    conectividad2020: {
        es: {
            title: 'Conectividad en la región LAC: 2020',
            items: [
                { id: 'p1', label: 'Resumen' },
                { id: 'p2', label: 'Introducción' },
                { id: 'p3', label: 'Metodología y estudios anteriores' },
                { id: 'p4', label: 'Estudios 2020' },
                { id: 'p5', label: 'Comparando 2020 con 2017' },
                { id: 'p6', label: 'Latencia agregada comparada' },
                { id: 'p7', label: 'Clusters de latencia' },
                { id: 'p8', label: 'Comparando con 2017' },
                { id: 'p9', label: 'Conclusiones' }
            ]
        },
        en: {
            title: 'Connectivity in the LAC Region in 2020',
            items: [
                { id: 'p1', label: 'Abstract' },
                { id: 'p2', label: 'Introduction' },
                { id: 'p3', label: 'Methodology and Prior Studies' },
                { id: 'p4', label: 'Results of the 2020 Study' },
                { id: 'p5', label: '2020 versus 2017' },
                { id: 'p6', label: 'A Comparison of Aggregate Latency' },
                { id: 'p7', label: 'Latency Clusters' },
                { id: 'p8', label: 'Comparison with 2017' },
                { id: 'p9', label: 'Conclusions' }
            ]
        },
        pt: {
            title: 'Conectividade na região da LAC: 2020',
            items: [
                { id: 'p1', label: 'Resumo' },
                { id: 'p2', label: 'Introdução' },
                { id: 'p3', label: 'Metodologia e estudos anteriores' },
                { id: 'p4', label: 'Estudo 2020' },
                { id: 'p5', label: 'Comparando 2020 com 2017' },
                { id: 'p6', label: 'Latência agregada comparada' },
                { id: 'p7', label: 'Clusters de latência' },
                { id: 'p8', label: 'Comparando com 2017' },
                { id: 'p9', label: 'Conclusões' }
            ]
        }
    },
    optimizacionRedesBgp: {
        es: {
            title: 'Optimización de redes mediante un mejor iBGP',
            items: [
                { id: 'p0', label: 'Resumen' },
                { id: 'p1', label: 'Descripción del problema' },
                { id: 'p2', label: 'Situación actual' },
                { id: 'p3', label: 'Qué aporta esta nueva aproximación' },
                { id: 'p4', label: '¿En qué estado está este trabajo?' },
                { id: 'p5', label: 'Un llamado a la acción' },
                { id: 'p6', label: 'Cómo colaborar' },
                { id: 'p7', label: 'Referencias' }
            ]
        },
        en: {
            title: 'Optimización de redes mediante un mejor iBGP',
            items: [
                { id: 'p0', label: 'Resumen' },
                { id: 'p1', label: 'Descripción del problema' },
                { id: 'p2', label: 'Situación actual' },
                { id: 'p3', label: 'Qué aporta esta nueva aproximación' },
                { id: 'p4', label: '¿En qué estado está este trabajo?' },
                { id: 'p5', label: 'Un llamado a la acción' },
                { id: 'p6', label: 'Cómo colaborar' },
                { id: 'p7', label: 'Referencias' }
            ]
        },
        pt: {
            title: 'Optimización de redes mediante un mejor iBGP',
            items: [
                { id: 'p0', label: 'Resumen' },
                { id: 'p1', label: 'Descripción del problema' },
                { id: 'p2', label: 'Situación actual' },
                { id: 'p3', label: 'Qué aporta esta nueva aproximación' },
                { id: 'p4', label: '¿En qué estado está este trabajo?' },
                { id: 'p5', label: 'Un llamado a la acción' },
                { id: 'p6', label: 'Cómo colaborar' },
                { id: 'p7', label: 'Referencias' }
            ]
        }
    },     
    interconexionBgpLocal: {
        es: {
            title: 'Interconexión BGP a nivel local en la región de AméricaLatina y el Caribe',
            items: [
                { id: 'p1', label: 'Resumen' },
                { id: 'p2', label: 'Introducción'},
                { id: 'p3', label: 'Objetivos'},
                { id: 'p4', label: 'Metodología'},
                { id: 'p5', label: 'Resultados preliminares' },
                { id: 'p6', label: 'Datos por IXP'},
                { id: 'p7', label: 'Conclusiones'}
            ]
        },
        en: {
            title: 'Local BGP Interconnection in Latin America and the Caribbean',
            items: [
                { id: 'p1', label: 'Abstract'},
                { id: 'p2', label: 'Introduction'},
                { id: 'p3', label: 'Goals'},
                { id: 'p4', label: 'Methodology'},
                { id: 'p5', label: 'Preliminary Findings'},
                { id: 'p6', label: 'Data by IXP'},
                { id: 'p7', label: 'Conclusions'}
            ]
        },
        pt: {
            title: 'Interconexão BGP no nível local na região da América Latina e o Caribe',
            items: [
                { id: 'p1', label: 'Resumo'},
                { id: 'p2', label: 'Introdução'},
                { id: 'p3', label: 'Objetivos'},
                { id: 'p4', label: 'Metodologia'},
                { id: 'p5', label: 'Resultados preliminares'},
                { id: 'p6', label: 'Dados por IXP'},
                { id: 'p7', label: 'Conclusões'}
            ]
        }
    },
    rootServerLocal: {
        es: {
            title: 'Uso de root servers del DNS en la región',
            items: [
                { id: 'p1', label: 'Resumen' },
                { id: 'p2', label: 'Introducción' },
                { id: 'p3', label: 'Root Servers y su Importancia' },
                { id: 'p4', label: 'Metodologia del Estudio' },
                { id: 'p5', label: 'Resultados' },
                { id: 'p6', label: 'Tiempos de respuesta nacionales hacia cada root server' },
                { id: 'p7', label: 'Tiempos de respuesta promedio por país' },
                { id: 'p8', label: 'Conclusiones' },
                { id: 'p9', label: 'Sobre el estudio' },
                { id: 'p10', label: 'Anexos' }
            ]
        },
        en: {
            title: 'Use of DNS Root Servers in Latin America',
            items: [
                { id: 'p1', label: 'Abstract' },
                { id: 'p2', label: 'Introduction' },
                { id: 'p3', label: 'Root Servers and their Importance' },
                { id: 'p4', label: 'Research Methodolgy' },
                { id: 'p5', label: 'Results' },
                { id: 'p6', label: 'National Response Times for Each Root Server' },
                { id: 'p7', label: 'Average Response Times By Country' },
                { id: 'p8', label: 'Conclusions' },
                { id: 'p9', label: 'About This Study' },
                { id: 'p10', label: 'Annexes' }
            ]
        },
        pt: {
            title: 'Uso de root servers del DNS en la región',
        },
    },
    dnsOverTls: {
        es: {
            title: 'Uso de DNS-over-TLS en Latinoamérica y el Caribe',
            items: [
                { id: 'p1', label: 'Resumen' },
                { id: 'p2', label: 'Objetivo' },
                { id: 'p3', label: 'Fundamentación' },
                { id: 'p4', label: 'Fuentes de datos' },
                { id: 'p5', label: 'Metodología' },
                { id: 'p6', label: 'Primeros resultados' },
                { id: 'p7', label: 'Conclusiones' }
            ]
        },
        en: {
            title: 'Use of DNS-over-TLS In Latin America and the Caribbean',
            items: [
                { id: 'p1', label: 'Summary' },
                { id: 'p2', label: 'Goal' },
                { id: 'p3', label: 'Rationale' },
                { id: 'p4', label: 'Data sources' },
                { id: 'p5', label: 'Methodology' },
                { id: 'p6', label: 'Initial Findings' },
                { id: 'p7', label: 'Conlusions' }
            ]
        },
        pt: {
            title: 'Uso do DNS-over-TLS na América Latina e o Caribe',
            items: [
                { id: 'p1', label: 'Resumo' },
                { id: 'p2', label: 'Objetivo' },
                { id: 'p3', label: 'Fundamentos' },
                { id: 'p4', label: 'Fontes de dados' },
                { id: 'p5', label: 'Metodologia' },
                { id: 'p6', label: 'Primeiros resultados' },
                { id: 'p7', label: 'Conclusões' }
            ]
        }
    },
    mejoresPracticasIxp: {
        es: {
            title: 'Mejores prácticas para IXP',
            items: [
                { id: 'p1', label: 'Infraestructura' },
                { id: 'p2', label: 'Servicio' },
                { id: 'p3', label: 'Operación' },
                { id: 'p4', label: 'Gobernanza' },
                { id: 'p5', label: 'Comunidad' }
            ]
        },
        en: {
            title: 'Best Practices for IXPs',
            items: [
                { id: 'p1', label: 'Infrastructure' },
                { id: 'p2', label: 'Service' },
                { id: 'p3', label: 'Operation' },
                { id: 'p4', label: 'Governance' },
                { id: 'p5', label: 'Community' }
            ]
        },
        pt: {
            title: 'Melhores práticas para IXP',
            items: [
                { id: 'p1', label: 'Infraestrutura' },
                { id: 'p2', label: 'Serviço' },
                { id: 'p3', label: 'Operação' },
                { id: 'p4', label: 'Gobernança' },
                { id: 'p5', label: 'Comunidade' }
            ]
        }
    },
    conectividadEnLac: {
        es: {
            title: 'Análisis de los caminos del tráfico dentro de cada país de la región LAC',
            items: [
                { id: 'resumen_select', label: 'Resumen Ejecutivo' },
                { id: 'introduccion_select', label: 'Introducción: análisis de caminos del tráfico regional' },
                { id: 'datosusados_select', label: 'Datos usados en este estudio' },
                { id: '5500redes_select', label: 'Cobertura de la campaña de mediciones' },
                { id: 'impactolatencia_select', label: 'Latencias' },
                { id: 'perspectivacaminos_select', label: 'Caminos' },
                { id: 'caminoslatencias_select', label: 'Latencias y caminos' },
                { id: 'grafos_select', label: 'Grafos' },
                { id: 'ixp_select', label: 'IXP' },
                { id: 'geolocalizacion_select', label: 'Geolocalización' },
                { id: 'conclusion_select', label: 'Conclusiones' },
                { id: 'anexo1_select', label: 'Anexo 1: Destinos de traceroutes salientes (ASNs)' },
                { id: 'anexo2_select', label: 'Anexo 2: Rutas con circuitos por el extranjero' },
                {
                    id: 'anexo3grafos_select',
                    label: 'Anexo 3: Grafos de los países de LAC',
                    subItems: [
                        { id: 't1', label: 'Argentina' },
                        { id: 't2', label: 'Bolivia' },
                        { id: 't3', label: 'Brasil' },
                        { id: 't4', label: 'Chile' },
                        { id: 't5', label: 'Colombia' },
                        { id: 't6', label: 'Costa Rica' },
                        { id: 't7', label: 'República Dominicana' },
                        { id: 't8', label: 'Ecuador' },
                        { id: 't9', label: 'Guyana Francesa' },
                        { id: 't10', label: 'Guatemala' },
                        { id: 't11', label: 'Guyana' },
                        { id: 't12', label: 'Honduras' },
                        { id: 't13', label: 'Haití' },
                        { id: 't14', label: 'México' },
                        { id: 't15', label: 'Nicaragua' },
                        { id: 't16', label: 'Panamá' },
                        { id: 't17', label: 'Perú' },
                        { id: 't18', label: 'Paraguay' },
                        { id: 't19', label: 'El Salvador' },
                        { id: 't20', label: 'Trinidad y Tobago' },
                        { id: 't21', label: 'Uruguay' },
                        { id: 't22', label: 'Venezuela' }
                    ]
                }
            ]
        },
        en: {
            title: 'Analysis of the paths followed by traffic within each country of LAC region',
            items: [
                { id: 'resumen_select', label: 'Executive Summary' },
                { id: 'introduccion_select', label: 'Introduction: Regional Traffic Path Analyses' },
                { id: 'datosusados_select', label: 'Data Used in this Study' },
                { id: '5500redes_select', label: 'Scope of the Measurement Campaign' },
                { id: 'impactolatencia_select', label: 'Latency' },
                { id: 'perspectivacaminos_select', label: 'Paths' },
                { id: 'caminoslatencias_select', label: 'Latency and Paths' },
                { id: 'grafos_select', label: 'Graphs' },
                { id: 'ixp_select', label: 'Internet Exchange Points' },
                { id: 'geolocalizacion_select', label: 'Geolocation' },
                { id: 'conclusion_select', label: 'Conclusions' },
                { id: 'anexo1_select', label: 'Annex 1: Outgoing Traceroute Destinations (ASNs)' },
                { id: 'anexo2_select', label: 'Annex 2: Routes with Segments outside the Country' },
                {
                    id: 'anexo3grafos_select',
                    label: 'Annex 3: Graphs for the Different Countries in LAC',
                    subItems: [
                        { id: 't1', label: 'Argentina' },
                        { id: 't2', label: 'Bolivia' },
                        { id: 't3', label: 'Brasil' },
                        { id: 't4', label: 'Chile' },
                        { id: 't5', label: 'Colombia' },
                        { id: 't6', label: 'Costa Rica' },
                        { id: 't7', label: 'República Dominicana' },
                        { id: 't8', label: 'Ecuador' },
                        { id: 't9', label: 'Guyana Francesa' },
                        { id: 't10', label: 'Guatemala' },
                        { id: 't11', label: 'Guyana' },
                        { id: 't12', label: 'Honduras' },
                        { id: 't13', label: 'Haití' },
                        { id: 't14', label: 'México' },
                        { id: 't15', label: 'Nicaragua' },
                        { id: 't16', label: 'Panamá' },
                        { id: 't17', label: 'Perú' },
                        { id: 't18', label: 'Paraguay' },
                        { id: 't19', label: 'El Salvador' },
                        { id: 't20', label: 'Trinidad y Tobago' },
                        { id: 't21', label: 'Uruguay' },
                        { id: 't22', label: 'Venezuela' }
                    ]
                }
            ]
        },
        pt: {
            title: 'Análise das rotas do tráfego dentro de cada país da região LAC',
            items: [
                { id: 'resumen_select', label: 'Resumo Executivo' },
                { id: 'introduccion_select', label: 'Introdução: análise de caminhos do tráfego regional' },
                { id: 'datosusados_select', label: 'Dados usados neste estudo' },
                { id: '5500redes_select', label: 'Cobertura da campanha de medições' },
                { id: 'impactolatencia_select', label: 'Latências' },
                { id: 'perspectivacaminos_select', label: 'Caminhos' },
                { id: 'caminoslatencias_select', label: 'Latências e caminhos' },
                { id: 'grafos_select', label: 'Grafos' },
                { id: 'ixp_select', label: 'IXP' },
                { id: 'geolocalizacion_select', label: 'Geolocalização' },
                { id: 'conclusion_select', label: 'Conclusões' },
                { id: 'anexo1_select', label: 'Anexo 1: Destinos de traceroutes de saída (ASN)' },
                { id: 'anexo2_select', label: 'Anexo 2: Rotas com circuitos no exterior' },
                {
                    id: 'anexo3grafos_select',
                    label: 'Anexo 3: Grafos dos países da ALC',
                    subItems: [
                        { id: 't1', label: 'Argentina' },
                        { id: 't2', label: 'Bolivia' },
                        { id: 't3', label: 'Brasil' },
                        { id: 't4', label: 'Chile' },
                        { id: 't5', label: 'Colombia' },
                        { id: 't6', label: 'Costa Rica' },
                        { id: 't7', label: 'República Dominicana' },
                        { id: 't8', label: 'Ecuador' },
                        { id: 't9', label: 'Guyana Francesa' },
                        { id: 't10', label: 'Guatemala' },
                        { id: 't11', label: 'Guyana' },
                        { id: 't12', label: 'Honduras' },
                        { id: 't13', label: 'Haití' },
                        { id: 't14', label: 'México' },
                        { id: 't15', label: 'Nicaragua' },
                        { id: 't16', label: 'Panamá' },
                        { id: 't17', label: 'Perú' },
                        { id: 't18', label: 'Paraguay' },
                        { id: 't19', label: 'El Salvador' },
                        { id: 't20', label: 'Trinidad y Tobago' },
                        { id: 't21', label: 'Uruguay' },
                        { id: 't22', label: 'Venezuela' }
                    ]
                }
            ]
        }
    },
    tiempoNubeAnycastLactldLac: {
        es: {title: 'Tiempo de respuesta a la nube DNS anycast de LACTLD desde Latinoamérica y el Caribe'},
        en: {title: 'Response Times from Latin America and the Caribbean to the LACTLD Anycast DNS Cloud'},
        pt: {title: 'Tempo de resposta à nuvem DNS anycast do LACTLD desde a América Latina e o Caribe'},
    },
    seguridadRuteoLac: {
        es: {title: 'Seguridad en el ruteo de América Latina y el Caribe'},
        en: {title: 'Routing Security in Latin America and the Caribbean'},
        pt: {title: 'Segurança no roteamento da América Latina e do Caribe'}
    },
     
    /* IPv6 */
    soporteIPv6EnEquiposCPE2020: {
        es: {
            title: 'Informe sobre soporte de IPv6 en equipos CPE - Versión 1 (2020)',
            items: [
                { id: 'p1', label: 'Resumen' },
                { id: 'p2', label: 'Objetivo' },
                { id: 'p3', label: 'Motivo' },
                { id: 'p4', label: 'Alcance' },
                { id: 'p5', label: 'Introducción' },
                { id: 'p6', label: 'Consideraciones Iniciales' },
                { id: 'p7', label: 'Mecanismos de Transición' },
                { id: 'p8', label: 'IPv4 as a Service' },
                { id: 'p9', label: 'Recolección de Información' },
                { id: 'p10', label: 'Encuestas a ISPs' },
                { id: 'p11', label: 'Consultas a Fabricantes de CPEs' },
                { id: 'p12', label: 'Conclusiones' },
                { id: 'p13', label: 'Referencias' }
            ]
        },
        en: {
            title: 'Informe sobre soporte de IPv6 en equipos CPE - Versión 1 (2020)',
            items: [
                { id: 'p1', label: 'Resumen' },
                { id: 'p2', label: 'Objetivo' },
                { id: 'p3', label: 'Motivo' },
                { id: 'p4', label: 'Alcance' },
                { id: 'p5', label: 'Introducción' },
                { id: 'p6', label: 'Consideraciones Iniciales' },
                { id: 'p7', label: 'Mecanismos de Transición' },
                { id: 'p8', label: 'IPv4 as a Service' },
                { id: 'p9', label: 'Recolección de Información' },
                { id: 'p10', label: 'Encuestas a ISPs' },
                { id: 'p11', label: 'Consultas a Fabricantes de CPEs' },
                { id: 'p12', label: 'Conclusiones' },
                { id: 'p13', label: 'Referencias' }
            ]
        },
        pt: {
            title: 'Informe sobre soporte de IPv6 en equipos CPE - Versión 1 (2020)',
            items: [
                { id: 'p1', label: 'Resumen' },
                { id: 'p2', label: 'Objetivo' },
                { id: 'p3', label: 'Motivo' },
                { id: 'p4', label: 'Alcance' },
                { id: 'p5', label: 'Introducción' },
                { id: 'p6', label: 'Consideraciones Iniciales' },
                { id: 'p7', label: 'Mecanismos de Transición' },
                { id: 'p8', label: 'IPv4 as a Service' },
                { id: 'p9', label: 'Recolección de Información' },
                { id: 'p10', label: 'Encuestas a ISPs' },
                { id: 'p11', label: 'Consultas a Fabricantes de CPEs' },
                { id: 'p12', label: 'Conclusiones' },
                { id: 'p13', label: 'Referencias' }
            ]
        }
    },
    tendenciasIPv62016: {
        es: { title : 'Estadísticas y tendencias: el despliegue de IPv6 En América Latina y el Caribe 2016-2020'},
        en: { title : 'Statistics And Trends: IPv6 Deployment In Latin America And The Caribbean 2016-2020'},
        pt: { title : 'Estatísticas e tendências: a implementação do IPv6 na América Latina E O Caribe 2016-2020'},
    },
    operadoresDespliegueIPv6: {
        es: { title : 'El comportamiento de operadores en el despliegue de IPv6 en América Latina y el Caribe'},
        en: { title : 'Operators’ Behavior In Relation To IPv6 Deployment In Latin America And The Caribbean'},
        pt: { title : 'O comportamento das operadoras na implementação do IPv6 na América Latina e o Caribe'},
    },
    soporteIPv6EnEquiposCPE2021: {
        es: { title : 'Informe sobre soporte de IPv6 en equipos CPE - Versión 2 (2021)'},
        en: { title : 'Informe sobre soporte de IPv6 en equipos CPE - Versión 2 (2021)'},
        pt: { title : 'Informe sobre soporte de IPv6 en equipos CPE - Versión 2 (2021)'},
    },
    incidentesEnrutamiento2024: {
        es: {title: 'Análisis de incidentes de enrutamiento en la región'},
        en: {title: 'Análisis de incidentes de enrutamiento en la región'},
        pt: {title: 'Análisis de incidentes de enrutamiento en la región'},
    },
    rfc8950: {
        es: {title: 'Implementación del RFC8950 para la transición a IPv6-only: soporte de IPv4aaS en redes MikroTik'},
        en: {title: 'Implementing RFC8950 for Transitioning to IPv6 Only: IPv4aaS Support in Mikrotik Networks'},
        pt: {title: 'Implementação do RFC8950 para a transição para só IPv6: Suporte do IPv4aaS em Redes MikroTik'},
    }
     
};